import {handleActions} from 'redux-actions';
import actions from './community.actions';

const reducer = handleActions(
	{
		[actions.communityLoading]: (state, {payload}) => null,
		[actions.communityLoaded]: (state = {}, {payload}) => ({
			...state,
			...payload
		}),
		[actions.communityMembersLoaded]: (state = {}, {payload}) => ({
			...state,
			members: [...payload]
		}),
		[actions.communityJoined]: (state = {}, {payload}) =>
			state && {...state, members: [...state.members, {...payload}]},
		[actions.communityMembershipApproved]: (state = {}, {payload}) => ({
			...state,
			members: state.members.map(member =>
				member.user.uuid === payload
					? {...member, membership: {...member.membership, status: 'approved'}}
					: member
			)
		}),
		[actions.communityMembershipRejected]: (state = {}, {payload}) => ({
			...state,
			members: state.members.filter(member => member.user.uuid !== payload)
		}),
		[actions.communityAdminApply]: (state = {}, {payload}) => ({
			...state,
			members: state.members.map(member =>
				member.user.uuid === payload
					? {...member, membership: {...member.membership, admin: true}}
					: member
			)
		}),
		[actions.communityAdminRevoke]: (state = {}, {payload}) => ({
			...state,
			members: state.members.map(member =>
				member.user.uuid === payload
					? {...member, membership: {...member.membership, admin: false}}
					: member
			)
		}),
		[actions.communitySetType]: (state = {}, {payload}) => ({
			...state,
			type: payload
		}),
		[actions.communitySetNoticesEnabled]: (state = {}, {payload}) => ({
			...state,
			noticesEnabled: payload
		}),
		[actions.communitySetNoticesAllowAll]: (state = {}, {payload}) => ({
			...state,
			noticesAllowAll: payload
		}),
		[actions.communityUpdateField]: (state, {payload}) => ({
			...state,
			...payload,
			profile: payload.profile
				? {
						...(state.profile || {}),
						...payload.profile
				  }
				: state.profile
		}),
		[actions.communityUpdateAbout]: (state = {}, {payload}) => ({
			...state,
			profile: {
				...state.profile,
				about: payload
			},
			editingField: null
		}),
		[actions.communityUpdateBrief]: (state = {}, {payload}) => ({
			...state,
			profile: {
				...state.profile,
				brief: payload
			},
			editingField: null
		}),
		[actions.communityUpdateName]: (state = {}, {payload}) => ({
			...state,
			name: payload,
			editingField: null
		}),
		[actions.communityUpdateCategory]: (state, {payload}) => ({
			...state,
			category: payload,
			editingField: null
		}),
		[actions.communityUpdateLocation]: (state, {payload}) => ({
			...state,
			location: {
				...payload
			},
			editingField: null
		}),
		[actions.communityEditingField]: (state, {payload}) => ({
			...state,
			editingField: payload === state.editingField ? null : payload // Toggle if already editing, otherwise switch
		}),
		[actions.communityEditContacts]: state => ({
			...state,
			editingContacts: [...(state && state.contacts)] // Copy contacts into a separate editing area
		}),
		[actions.communityChangeEditContacts]: (state, {payload: {type, detail}}) => {
			let found = false;
			let editingContacts = state
				? state.editingContacts.map(contact => {
						if (contact.type === type) {
							found = true;
							return {type, detail}; // Return new contact object
						} else {
							return contact;
						}
				  })
				: [];

			if (!found) {
				// If new, add it to the list
				editingContacts = editingContacts.concat({type, detail});
			}

			return {
				...state,
				editingContacts
			};
		},
		[actions.communityCommitContacts]: (state, {payload}) => ({
			...state,
			contacts: [...payload]
		}),
		[actions.communityDragOverBackgroundImage]: state => ({
			...state,
			draggingOverBackgroundImage: true
		}),
		[actions.communityDragOutBackgroundImage]: state => ({
			...state,
			draggingOverBackgroundImage: null
		}),
		[actions.communityUpdatingBackgroundImage]: (state, {payload}) => ({
			...state,
			updatingBackgroundImage: true
		}),
		[actions.communityUpdateBackgroundImage]: (state, {payload}) => ({
			...state,
			profile: {
				...state.profile,
				backgroundImage: payload
			},
			updatingBackgroundImage: null,
			editingField: null
		}),
		[actions.communityDeleteImage]: (state, {payload}) => ({
			...state,
			profile: {
				...state.profile,
				images: state.profile.images.filter(image => image.image !== payload)
			},
			editingField: null
		}),
		[actions.communityAddingProfileImage]: (state, {payload}) => ({
			...state,
			addingProfileImage: true,
			editingField: null
		}),
		[actions.communityAddedProfileImage]: (state, {payload}) => ({
			...state,
			profile: {
				...state.profile,
				images: state.profile.images.concat(payload)
			},
			addingProfileImage: null,
			editingField: null
		}),
		[actions.communityDragOverProfileImage]: state => ({
			...state,
			draggingOverProfileImage: true
		}),
		[actions.communityDragOutProfileImage]: state => ({
			...state,
			draggingOverProfileImage: null
		}),
		[actions.communityRemove]: () => null,
		[actions.communityMute]: (state = {}, {payload: {isMuted, userUuid}}) => ({
			...state,
			members: state.members.map(member =>
				member.user.uuid === userUuid
					? {...member, membership: {...member.membership, muted: isMuted}}
					: member
			)
		}),
		[actions.communityResetColour]: state => ({
			...state,
			profile: {
				...state.profile,
				customColour: '#004f71'
			}
		}),
		[actions.communitySetImgs]: (state, {payload}) => ({
			...state,
			profile: {
				...state.profile,
				images: payload
			}
		})
	},
	null
);

export default reducer;



// WEBPACK FOOTER //
// ./src/community/community.reducer.js